import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'RENEWAL_PLANS_GET',
  GET_SUCCESS: 'RENEWAL_PLANS_GET_SUCCESS',
  GET_FAILURE: 'RENEWAL_PLANS_GET_FAILURE',
};

export const get = actions.get(
  studentId =>
    `${BASE_URL}/students/${studentId}/renewal-plans/?include_payment_access_info=true`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
